import '../../Styles/ReusableComponents/skeletonButton.scss';

const SkeletonButton = ({
  width,
  showIcon = true,
  iconSize = 22,
  className = ''
}) => {
  return (
    <div className={`skeleton-button svg---text ${className}`}>
      {showIcon && (
        <div
          className="skeleton-button__icon"
          style={{ height: `${iconSize}px` }}
        />
      )}
      <div
        className="skeleton-button__text"
        style={width ? { width: `${width}px` } : undefined}
      />
    </div>
  );
};

export default SkeletonButton;